import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from '../../../../core/services/modal/modal.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [TranslateModule,CommonModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  @Input() title: string = "";
  @Input() message: string = "";
  @Input() confirmText: string = "";
  @Input() cancelText: string = "";
  @Output() onConfirm: EventEmitter<any> = new EventEmitter();



  constructor(private modalService: ModalService) { }


  closeModal() {
    this.modalService.closeAll();
  }

  confirm() {
    this.onConfirm.emit(true);
    this.modalService.closeAll();
  }
}
